import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { apiVerificationCodePost } from '@api/session';
import { setJwt } from '@utils/session';
import { redirectTo } from '@utils/routing';
import { LoaderFullPage } from '@app/loaders/LoaderFullPage';
import { ErrorScreenExpiredLink } from '@components/ErrorScreen/index';

interface TLoginVerificationCodeParams extends Record<
  string,
  string | undefined
> {
  userId?: string;
  verificationCode?: string;
}

export const PageLoginVerificationCode: FC = () => {
  const [isLinkExpired, setIsLinkExpired] = useState(false);

  const { userId, verificationCode } =
    useParams<TLoginVerificationCodeParams>();

  const redirectPage =
    localStorage.getItem('EmployerView::authRedirectPath') ||
    `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/`;

  const verifyCode = async (): Promise<void> => {
    if (!userId || !verificationCode) {
      setIsLinkExpired(true);
      return;
    }

    try {
      const jwtResponse = await apiVerificationCodePost({
        userId,
        verificationCode,
      });

      setJwt(jwtResponse);

      redirectTo(redirectPage);
    } catch (_error) {
      setIsLinkExpired(true);
    }
  };

  useEffect(() => {
    queueMicrotask(() => {
      verifyCode();
    });
  }, [userId, verificationCode]);

  return isLinkExpired ? <ErrorScreenExpiredLink /> : <LoaderFullPage />;
};
